<template>
  <button
    :aria-pressed="props.hazardViewType === hazards.activeView"
    class="h-7 w-12 overflow-hidden text-type-secondary transition-colors duration-200 2xs:w-14"
    @click="handleClick"
  >
    <div
      class="text-center"
      :class="{
        'text-white': props.hazardViewType === hazards.activeView,
      }"
    >
      {{ hazardViewType }}
    </div>
  </button>
</template>

<script setup lang="ts">
import { HazardView, useHazardsStore } from '@/features/hazards';

const props = defineProps<{
  hazardViewType: HazardView;
}>();

const hazards = useHazardsStore();

const handleClick = () => {
  hazards.setActiveView(props.hazardViewType);
};
</script>
